/* IOTR 2026-10-22: make the whole product card open the product, like its title link.
   Loaded by snippets/iotr-podium-webchat.liquid (sitewide, deferred). One delegated listener on document,
   so cards added later by filters, sort or "load more" work too. Card markup and the links are unchanged. */
(function () {
  if (window.iotrCardClick) return;
  window.iotrCardClick = true;

  // Anything interactive inside a card keeps its own behaviour (swatches, wishlist, quick view, quick add, image dots).
  var IGNORE = [
    'a', 'button', 'input', 'select', 'textarea', 'label', 'summary', '[role="button"]', '[role="link"]', '[contenteditable]',
    'quick-view', '.product-card-quickview', '.product-card--add-to-cart-button-container',
    '.product-card-swatches--container', '.custom_product_color .select-option', '.product-card-sizes',
    '.product-secondary-images-nav', '[class*="wishlist"]', '[data-iotr-no-card-click]'
  ].join(',');

  function cardLink(e) {
    if (!e.target || e.target.nodeType !== 1 || typeof e.target.closest !== 'function') return null;
    var card = e.target.closest('product-card');
    if (!card || e.target.closest(IGNORE)) return null;
    // Don't navigate when the shopper is selecting text in the card.
    var sel = window.getSelection && window.getSelection();
    if (sel && !sel.isCollapsed && card.contains(sel.anchorNode)) return null;
    // Title first: the metal swatches update its href, so the chosen metal is kept.
    return card.querySelector('a.product-card-title[href*="/products/"]') ||
      card.querySelector('a.product-featured-image-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    var link = cardLink(e);
    if (!link) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) {
      window.open(link.href, '_blank', 'noopener');
    } else {
      link.click();
    }
  });

  // Middle-click: new tab, like a link. Stop Chrome's autoscroll from starting first.
  document.addEventListener('mousedown', function (e) {
    if (e.button === 1 && cardLink(e)) e.preventDefault();
  });
  document.addEventListener('auxclick', function (e) {
    if (e.defaultPrevented || e.button !== 1) return;
    var link = cardLink(e);
    if (link) window.open(link.href, '_blank', 'noopener');
  });

  var style = document.createElement('style');
  style.textContent = 'product-card.product-card { cursor: pointer; }';
  document.head.appendChild(style);
})();
